import { useState } from 'react';

type OptimisticUpdateStatus = 'settled' | 'pending';

/**
 * A fairly simple hook that provides a way to keep track of the status of an
 * optimistic update. Mainly here to keep things consistent.
 */
export function useOptimisticUpdateStatus() {
  const [optimisticUpdateStatus, setOptimisticUpdateStatus] =
    useState<OptimisticUpdateStatus>('settled');

  return {
    optimisticUpdateStatus,
    setOptimisticUpdateStatus,
  };
}
